import { inferLiteral } from "client/utils"
import {
    SilSafetyFunction,
    SilResultSafetyFunction,
} from "server/models"
import * as types from "./types"


export const setSilResultSafetyFunctionList = (safetyFunctionList: SilSafetyFunction[]) => ({
    type: inferLiteral(types.SIL_RESULT_SAFETY_FUNCTION_LIST),
    safetyFunctionList,
})
export const setSilResultCalculatedSafetyFunction = (safetyFunction: SilResultSafetyFunction) => ({
    type: inferLiteral(types.SIL_RESULT_CALCULATED_SAFETY_FUNCTION),
    safetyFunction,
})
export const setSilResultUpdatedDevices = (updatedDevices: number) => ({
    type: inferLiteral(types.SIL_RESULT_UPDATED_DEVICES),
    updatedDevices,
})
export const setSilResultReloadList = (value: boolean) => ({
    type: inferLiteral(types.SIL_RESULT_RELOAD_LIST),
    value,
})
